export default __webpack_public_path__ + "static/media/34t.81933c74.jpg";